import React from 'react';
import { LineChart } from './styles';

const Line: React.FC<any> = ({ ...props }) => {
  return <LineChart {...props} />;
};
export default Line;
